"use client"

import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { useParams, useLocation } from "react-router-dom"
import InfoGeneralBufete from "@/components/Ecommerce/InfoGeneralBufete"
import EquipoAbogados from "@/components/Ecommerce/EquipoAbogados"
import AreasPractica from "@/components/Ecommerce/AreasPractica"
import ResenasBufete from "@/components/Ecommerce/ResenasBufete"
import CasosDestacados from "@/components/Ecommerce/CasosDestacados"
import ContactoBufete from "@/components/Ecommerce/ContactoBufete"


const PerfilBufetePage = () => {
  const { id } = useParams(); // Obtiene el ID de la URL
  const location = useLocation(); // Obtiene los datos enviados con navigate
  const firmData = location.state?.firmData;
  const [bufeteData, setBufeteData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [activeTab, setActiveTab] = useState("info")

  useEffect(() => {
    // Simular carga de datos
    const fetchData = async () => {
      setIsLoading(true)
      // Aquí irían las llamadas a la API real
      setTimeout(() => {
        setBufeteData(firmData)
        setIsLoading(false)
      }, 1500)
    }

    fetchData()
  }, [])
console.log(bufeteData)
  const tabs = [
    { id: "info", label: "Información General" },
    { id: "equipo", label: "Equipo" },
    { id: "areas", label: "Áreas de Práctica" },
    { id: "casos", label: "Casos Destacados" },
    { id: "resenas", label: "Reseñas" },
    { id: "contacto", label: "Contacto" },
  ]

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="animate-pulse">
          <div className="h-64 bg-gray-200 rounded-lg mb-8" />
          <div className="h-8 bg-gray-200 w-1/3 rounded mb-4" />
          <div className="h-4 bg-gray-200 w-2/3 rounded mb-8" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="h-40 bg-gray-200 rounded" />
            <div className="h-40 bg-gray-200 rounded" />
            <div className="h-40 bg-gray-200 rounded" />
          </div>
        </div>
      </div>
    )
  }

  if (!bufeteData) {
    return (
      <div className="container mx-auto px-4 py-8">
        <p className="text-center text-gray-600">No se encontró información del bufete.</p>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Portada */}
      <div className="relative h-64 md:h-96 overflow-hidden">
        <motion.img
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
          src={bufeteData.coverImage}
          alt={bufeteData.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50" />
        <div className="absolute bottom-0 left-0 right-0 p-8">
          <div className="container mx-auto flex items-end space-x-6">
            <motion.img
              initial={{ y: 100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              src={bufeteData.logoImage}
              alt="Logo"
              className="w-24 h-24 md:w-32 md:h-32 rounded-lg border-4 border-white shadow-lg"
            />
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="text-white"
            >
              <h1 className="text-3xl md:text-4xl font-bold">{bufeteData.name}</h1>
              <p className="text-lg md:text-xl opacity-90">{bufeteData.eslogan}</p>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Navegación por pestañas */}
      <div className="sticky top-0 bg-white shadow-md z-10">
        <div className="container mx-auto px-4">
          <div className="flex overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-4 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? "border-[var(--gold)]  text-[var(--gold)] "
                    : "border-transparent text-gray-600 hover:text-gray-800"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Contenido principal */}
      <div className="container mx-auto px-4 py-8">
        <div className="space-y-8">
          {activeTab === "info" && <InfoGeneralBufete data={bufeteData} />}
          {activeTab === "equipo" && <EquipoAbogados equipo={bufeteData.team} />}
          {activeTab === "areas" && <AreasPractica areas={bufeteData.practiceAreas} />}
          {activeTab === "casos" && <CasosDestacados casos={bufeteData.highlightedCases} />}
          {activeTab === "resenas" && <ResenasBufete resenas={bufeteData.reviews} rating={bufeteData.rating} />}
          {activeTab === "contacto" && <ContactoBufete data={bufeteData} />}
        </div>
      </div>
    </div>
  )
}

export default PerfilBufetePage

